import React, { useEffect } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useAuth } from "context/AuthProvider";
import { FaUser } from "react-icons/fa";
import Banner from "views/admin/profile/components/Banner";
import { Modal, ModalOverlay, ModalContent, ModalBody } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import { MdClose, MdArrowDropDown } from "react-icons/md";
import logo from "assets/img/auth/smart_roots.png";
import cor_logo from "assets/svg/cor_logo.svg";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";

const Navbar = (props) => {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <nav className="sticky top-0 z-40 flex flex-row flex-wrap items-center justify-between bg-white p-2 shadow-[0px_1px_4px_-1px_rgba(0,0,0,0.15)] dark:bg-[#fff]" >
      <div className="ml-[6px]">
        <div className="flex items-center">
          <Link to="/">
            <div className="mt-1 ml-1  text-[26px] font-bold uppercase text-navy-700 dark:text-white w-[200px]">
              <img src={logo} alt="" className="w-[100%]" />
            </div>
          </Link>
        </div>
        {/* <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div> */}
        {/* <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p> */}
      </div>

      <div className="relative mt-[3px] flex h-[61px]  flex-grow items-center justify-around gap-2 px-2 py-2 md:flex-grow-0 md:gap-1  xl:gap-2">
      {/* <Dropdown
          button={
            <div className="flex cursor-pointer items-center gap-2 bg-white rounded-md px-2 py-[3px] dark:!border-white/10 text-[16px]">
              Websites
              <MdArrowDropDown className="h-4 w-4 text-gray-600 dark:text-white" />
            </div>
          }
          children={
            <ul className="flex w-[120px] flex-col gap-2 rounded-[10px] bg-white p-2 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none max-h-[180px] overflow-y-scroll">
              <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                Website 1
              </li>
              <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                Website 2
              </li>
              <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                Website 3
              </li>
              <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                Website 4
              </li>
              <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                Website 5
              </li>
            </ul>
          }
          classNames={"py-2 top-8 -left-[8px] md:-left-[8px] w-max"}
          animation="origin-top transition-all duration-300 ease-in-out"
        /> */}
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div> */}
        
        {/* Profile & Dropdown */}
        {/* <img className="w-16 mr-4" src={cor_logo} alt="Cor" /> */}
        <button className="flex" onClick={onOpen}>
          <span className="cursor-pointer rounded-full bg-lightPrimary p-3 text-customBlue dark:bg-navy-700">
            <FaUser className="h-3 w-3" />
          </span>
        </button>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          className="!z-[1010]"
          motionPreset="scale"
        >
          <ModalOverlay className="bg-[#000] !opacity-40 backdrop-blur-xl" />
          <ModalContent className="top-[15vh] !z-[1002] !m-auto !max-w-[80%] sm:!max-w-[30%]">
            <ModalBody>
              <MdClose
                onClick={onClose}
                className="absolute top-3 right-3 z-10 h-5 w-5 cursor-pointer rounded-md bg-white/25 text-white"
              />
              <Banner />
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </nav>
  );
};

export default Navbar;
